module.exports = __webpack_public_path__ + "static/media/delete.a17c4ead.png";